import { ITop3Info, ITop3Item } from '@/types';
import {
  StyledSwiper,
  SwiperWrap,
  TitleWrap,
  Wrapper,
} from '@/components/templates/collectTop3CreditCard/CollectTop3CreditCard.styled';
import { IntersectionObserver } from '@/components/common';
import { Top3CreditCard } from '@/components/organisms';
import { useCallback } from 'react';
import { clickEventHandler } from '@/helpers';
import { useCommonParams } from '@/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperOptions } from 'swiper';
import { COMPONENT_TYPE } from '@/const';
import { Heading } from '@/components/atoms';

const CollectTop3CreditCard = (props: ITop3Info) => {
  const { ads = [], title } = props;
  const { trackCd, osType, mediaSeq, trackCdType, page } = useCommonParams();

  const handleClick = useCallback(
    async (item: ITop3Item) => {
      await clickEventHandler({
        ...item,
        trackCd,
        osType,
        mediaSeq,
        trackCdType,
        componentName: COMPONENT_TYPE.CARD_TOP,
      });
    },
    [trackCd, osType, mediaSeq, trackCdType],
  );

  const swiperSettings: SwiperOptions = {
    slidesPerView: 3,
    spaceBetween: -5,
    centeredSlides: true,
    initialSlide: 0,
    loop: true,
  };

  const renderComponent = (item: ITop3Item, index: number) => {
    return (
      <SwiperSlide key={index} onClick={() => handleClick(item)}>
        <IntersectionObserver key={index} page={page} {...item} componentName={COMPONENT_TYPE.CARD_TOP}>
          <Top3CreditCard {...item} rank={index + 1} />
        </IntersectionObserver>
      </SwiperSlide>
    );
  };

  return (
    <Wrapper>
      <TitleWrap>
        <Heading level={2} color="gray-800">
          {title}
        </Heading>
      </TitleWrap>
      <SwiperWrap>
        <StyledSwiper>
          <Swiper {...swiperSettings} >
            {ads.length > 0 &&
              ads.map((item: ITop3Item, index: number) => renderComponent(item, index))}
          </Swiper>
        </StyledSwiper>
      </SwiperWrap>
    </Wrapper>
  );
};
export default CollectTop3CreditCard;
